// extracted by mini-css-extract-plugin
module.exports = {"loading":"selectControl_loading__12wdI"};